var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectAllWithWhiteFilledCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8093)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8093",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.0237C23.3738 49.024 21.7517 48.8605 20.1584 48.5354C17.0855 47.9061 14.1666 46.6779 11.5683 44.9208C7.70579 42.3136 4.6824 38.642 2.86445 34.3512C2.2501 32.8979 1.78121 31.3874 1.46465 29.8417C0.813866 26.6468 0.813866 23.3535 1.46465 20.1586C2.09402 17.0856 3.32226 14.1667 5.07936 11.5684C7.68672 7.70596 11.3582 4.68257 15.649 2.86445C17.1023 2.25018 18.6127 1.78129 20.1584 1.46465C23.3533 0.813866 26.6467 0.813866 29.8416 1.46465C32.9145 2.09402 35.8334 3.3223 38.4317 5.07946C42.2941 7.68685 45.3174 11.3584 47.1355 15.6491C47.7499 17.1024 48.2188 18.6129 48.5355 20.1586C49.1861 23.3535 49.1861 26.6468 48.5355 29.8417C47.906 32.9147 46.6777 35.8336 44.9205 38.432C42.3133 42.2944 38.6417 45.3177 34.351 47.1357C32.8977 47.75 31.3872 48.2188 29.8416 48.5354C28.2482 48.8605 26.6262 49.024 25 49.0237ZM14.4285 20.7018L12.0104 23.1194L22.1998 33.3088L38.6061 16.7295L36.1879 14.3119L22.1996 28.3007L14.4283 20.7019L14.4285 20.7018Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAllWithWhiteFilledCircle);
export default __webpack_public_path__ + "static/media/select_all_with_white_filled_circle.a61db4c74421ccdf49fea67c5551e1e2.svg";
export { ForwardRef as ReactComponent };